export default {
  title: 'Hallitse tiliä',
  buttons: {
    save: 'Tallenna',
    delete: 'Poista',
  },
};
